// #region License

/**
 * @license
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// #endregion

import * as React from "react";
import { List, Segment, Sidebar } from "semantic-ui-react";
import "./ApplicationMenu.less";
import { ApplicationMenuContextProvider } from "./ApplicationMenuContextProvider";
import { ApplicationFrameContext } from "../ApplicationFrame";
import { ApplicationNavigationContext } from "../ApplicationNavigation";
import { ApplicationPageContext } from "../ApplicationPage";
import { ApplicationMenuItem } from "./ApplicationMenuItem";
import { ApplicationMenuLoader } from "./ApplicationMenuLoader";
// import { ApplicationMenuAction } from './ApplicationMenuAction';
import { ApplicationMenuSearch } from "./ApplicationMenuSearch";
import { MenuIcon } from "../../assets/icons/Menu";
import { getApplicationClassName, getClassName } from "../utils/className";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const className = getApplicationClassName("menu");
const HistoryMenu = /*#__PURE__*/React.lazy(() => import("../../entities/History")
// eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
.then(({
  HistoryMenu
}) => ({
  default: HistoryMenu
})));
const FavoriteMenu = /*#__PURE__*/React.lazy(() => import("../../entities/Favorite")
// eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
.then(({
  FavoriteMenu
}) => ({
  default: FavoriteMenu
})));
const MenuMenu = /*#__PURE__*/React.lazy(() => import("../../entities/Menu")
// eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
.then(({
  MenuMenu
}) => ({
  default: MenuMenu
})));
const SpeedDialMenu = /*#__PURE__*/React.lazy(() => import("../../entities/SpeedDial")
// eslint-disable-next-line no-shadow, @typescript-eslint/no-shadow
.then(({
  SpeedDialMenu
}) => ({
  default: SpeedDialMenu
})));
export const ApplicationMenu = props => {
  const {
    module
  } = React.useContext(ApplicationNavigationContext);
  const {
    menu: {
      open,
      setOpen
    }
  } = React.useContext(ApplicationFrameContext);
  const {
    loading
  } = React.useContext(ApplicationPageContext);
  const [search, setSearch] = React.useState("");
  const handleShow = React.useCallback(() => {
    if (setOpen) {
      React.startTransition(() => {
        setOpen(true);
      });
    }
  }, [setOpen]);
  const handleHide = React.useCallback(() => {
    if (setOpen) {
      React.startTransition(() => {
        setOpen(false);
      });
    }
  }, [setOpen]);
  const handleSearch = React.useCallback(value => {
    React.startTransition(() => {
      setSearch(value);
    });
  }, []);
  React.useEffect(() => {
    React.startTransition(() => {
      setSearch("");
    });
  }, [module]);
  return React.useMemo(() => /*#__PURE__*/_jsx(ApplicationMenuContextProvider, {
    children: /*#__PURE__*/_jsx(Sidebar, {
      className: getClassName(className),
      as: Segment,
      visible: open,
      animation: "overlay",
      direction: "left",
      width: "wide",
      onShow: handleShow,
      onHide: handleHide,
      children: /*#__PURE__*/_jsxs(List, {
        selection: true,
        children: [/*#__PURE__*/_jsx(ApplicationMenuItem, {
          name: "menu.toggle",
          icon: /*#__PURE__*/_jsx(MenuIcon, {
            active: open
          }),
          content: open ? "Fermer le menu" : "Ouvrir le menu",
          onClick: open ? handleHide : handleShow
        }), /*#__PURE__*/_jsx("hr", {
          style: {
            borderColor: "transparent",
            marginBlockStart: "0em"
          }
        }), /*#__PURE__*/_jsx(React.Suspense, {
          fallback: /*#__PURE__*/_jsx(ApplicationMenuLoader, {}),
          children: /*#__PURE__*/_jsx(HistoryMenu, {
            module: module
          }, "history")
        }), /*#__PURE__*/_jsx("hr", {}), /*#__PURE__*/_jsx(React.Suspense, {
          fallback: /*#__PURE__*/_jsx(ApplicationMenuLoader, {}),
          children: /*#__PURE__*/_jsx(FavoriteMenu, {
            module: module
          }, "favorite")
        }), /*#__PURE__*/_jsx(ApplicationMenuSearch, {
          value: search,
          onChange: handleSearch
        }), loading ? /*#__PURE__*/_jsx(ApplicationMenuLoader, {}) : /*#__PURE__*/_jsx(React.Suspense, {
          fallback: /*#__PURE__*/_jsx(ApplicationMenuLoader, {}),
          children: /*#__PURE__*/_jsx(MenuMenu, {
            module: module,
            search: search
          }, "menu")
        }), /*#__PURE__*/_jsx(React.Suspense, {
          fallback: /*#__PURE__*/_jsx(ApplicationMenuLoader, {}),
          children: /*#__PURE__*/_jsx(SpeedDialMenu, {
            module: module
          }, "speedial")
        })]
      })
    })
  }), [open, search, module, loading, handleShow, handleHide]);
};